import { Link } from 'gatsby'
import React from 'react'
import Layout from '../components/Layout'
import RoundContainer from '../components/RoundContainer'

export default function about() {
  return (
    <Layout>
      <RoundContainer>
        <h3>How does this work?</h3>
        <p style={{ textAlign: 'left' }}>
          Covidvaxcount works by constantly checking the following three
          sources:{' '}
          <ol>
            <li>
              The CDC{' '}
              <a href="https://covid.cdc.gov/covid-data-tracker/#vaccinations">
                Covid Vaccine Tracker
              </a>
            </li>
            <li>
              Johns Hopkins{' '}
              <a href="https://github.com/govex/COVID-19/tree/master/data_tables">
                Centers for Civic Impact
              </a>
              {' vaccine data'}
            </li>
            <li>
              Individual state's vaccine dashboards, for example:{' '}
              <a href="https://tabexternal.dshs.texas.gov/t/THD/views/COVID-19VaccineinTexasDashboard/Summary?:isGuestRedirectFromVizportal=y&:embed=y">
                Texas
              </a>
              {', '}
              <a href="https://covid19vaccine.health.ny.gov/covid-19-vaccine-tracker">
                New York
              </a>
              {', '}
              and <a href="https://www.maine.gov/covid19/vaccines">Maine</a>
            </li>
          </ol>
          As these sources report new numbers, Covidvaxcount will always take
          the most recent data for each state, and use that to calculate the
          current total number of vaccinations. Whichever source is used for
          each state is linked directly next to that state's name in the table
          on the home page.
        </p>
        <p style={{ textAlign: 'left' }}>
          This means that <Link to="/">covidvaxcount.live</Link> is always the
          most up to date count of how many people have been vaccinated in the
          US.
        </p>
      </RoundContainer>
      <RoundContainer>
        <h3>What is the number? Is it total doses administered?</h3>
        <p style={{ textAlign: 'left' }}>
          The number calculated is described on the home page as: "members of
          the U.S. population who have received at least one dose of a COVID-19
          vaccine". This means that the number represents how many people in the
          US have received <i>at least one</i> dose of a COVID-19 vaccine.
        </p>
        <p style={{ textAlign: 'left' }}>
          Therefore the number is different from "total doses administered",
          because the same person can receive two doses. Such a case would only
          count as one, because the number calculated is "number of people who
          have received the vaccine".
        </p>
      </RoundContainer>
    </Layout>
  )
}
